<div class="modal-container" [style.width.%]="modalWidth">
    <div *ngIf="tabType === 'key_person_tab'">
        <div class="modal-header">
          <h2>Add Individual</h2>
          <button class="pt-0" mat-icon-button (click)="close()">
              <mat-icon>close</mat-icon>
          </button>
        </div>

        <form [formGroup]="form" (ngSubmit)="addIndividualDetails()" style="margin-bottom: 60px;">
          <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>

          <button class="blue_button float-end ms-3 me-3" mat-raised-button type="submit" >Submit</button>
          <button class="float-end" mat-stroked-button color="secondary" (click)="close()">Close</button>
        </form>
    </div>

    <div *ngIf="tabType === 'document_tab'">
        <div class="modal-header">
          <h2 *ngIf="isApplicable">Add Document</h2>
          <h2 *ngIf="!isApplicable">Not Applicable</h2>
          <button class="pt-0" mat-icon-button (click)="close()">
              <mat-icon>close</mat-icon>
          </button>
        </div>
        <form [formGroup]="docForm" class="mt-4">
            <div class="row" *ngIf="isApplicable">
              <div class="col-md-12">
                  <div class="form-group">
                   <mat-radio-group
                      formControlName="appDoc"
                      class="radio-group mt-4"
                      style="display: flex; gap: 15px;"
                    >
                      <mat-radio-button value="upload_from_device">
                        Upload from Your Device
                      </mat-radio-button>

                      <mat-radio-button value="upload_from_mobile">
                        Take Photo
                      </mat-radio-button>
                    </mat-radio-group>

                    <!-- <div class="radio-group mt-4" style="display: flex; gap: 15px;">
                      <label class="radio-label text-dark">
                        <input type="radio" formControlName="appDoc" value="upload_from_device" required checked>
                        Upload from Your Device
                      </label>
                      <label class="radio-label text-dark">
                        <input type="radio" formControlName="appDoc" value="upload_from_mobile" required>
                        Take Photo
                      </label>
                    </div> -->
                    <div *ngIf="docForm.get('appDoc')?.invalid" class="text-danger">
                      Please select an option.
                    </div>
                  </div>

                  <div class="form-group mt-4" *ngIf="docForm.get('appDoc')?.value === 'upload_from_device'">
                    <!-- <label for="fileUpload">{{docTitle}}</label> -->
                     <mat-form-field class="w-100">
                    <input
                      matInput
                      type="file"
                      id="fileUpload"
                      formControlName="uploadDocuments"
                      [attr.placeholder]="docForm.get('uploadDocuments')?.placeholder"
                      accept=".pdf,.doc,.docx,.jpg,.png,.xlsx,.csv,.txt,.jpeg,.heic"
                      required
                      class="form-control"
                      (change)="onFileSelected($event)"
                    />
                       <!--.tif,.tiff,.pdf,.txt,.csv,.odt,.ods,.bmp,.jpeg,.jpg,.png, gif, htm, html, mht, heic, xls, xlsx, zip, rar, tar, gzip, gz, ach-->
                    </mat-form-field>
                    <small class="form-text text-muted">
                      * Supported document types are pdf, doc, docx, jpg, png, xlsx, csv, txt, jpeg, heic
<!--                      {{ supporetsFiles }}-->
                    </small>
                    <div *ngIf="docForm.get('uploadDocuments')?.hasError('required') && formSubmitted">
                      <span class="text-danger">Select a file.</span>
                    </div>
                    <div *ngIf="selectedFiles.length > 0" class="mt-2">
                      <p>Selected files:</p>
                      <ul>
                        <li *ngFor="let file of selectedFiles">{{ file.name }}</li>
                      </ul>
                    </div>
                  </div>

                  <div class="form-group mt-4" *ngIf="docForm.get('appDoc')?.value === 'upload_from_mobile'">
                    <img *ngIf="capturedPhotoFromModal" [src]="capturedPhotoFromModal"
                          class="thumbnail-image"/>
                    <button class="blue_button mt-4" mat-raised-button type="submit" (click)="openPopUpForCaptureImg()">Take Photo</button>
                  </div>

              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-12 mt-4">
                <div class="custom-textarea-wrapper">
                  <label for="comments" *ngIf="!isApplicable">Comments*</label>
                  <label for="comments" *ngIf="isApplicable">Comments</label>
                  <textarea
                    id="comments"
                    formControlName="comments"
                    rows="5"
                    required
                    class="border-radius"
                  ></textarea>
                  <div *ngIf="!isApplicable">
                    <div *ngIf="docForm.get('comments')?.hasError('required')">
                      <span class="text-danger">Comments are required.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          <!-- <input type="file" formControlName="appDoc" #fileInput (change)="onFileSelected($event)" multiple> -->
          <!-- <formly-form [model]="uploadDocmodel" [fields]="uploadDocfields" [form]="uploadDocform"></formly-form> -->
           <button class="float-end" mat-stroked-button color="secondary" (click)="close()" >Close</button>
           <!-- upload doc -->
            <button *ngIf="isApplicable" class="blue_button float-end me-3" mat-raised-button type="submit" (click)="uploadAppDoc()">Submit</button>
            <!-- not Applicable -->
            <button *ngIf="!isApplicable" class="blue_button float-end me-3" mat-raised-button type="submit" (click)="uploadNotAppDoc()">Submit</button>

        </form>

    </div>

    <div *ngIf="tabType === 'lic_tab'">

      <div class="modal-header">
        <h2>Add License</h2>
        <button class="pt-0" mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-card>

        <form [formGroup]='searchinput' class="px-4 mt-4">
          <div class="comply row mt-4">
              <div class="col-sm-10 col-xs-12 col-lg-10 col-md-10">
                  <mat-form-field class=" w-100">
                    <mat-label>License</mat-label>
                      <input matInput formControlName='search_field'>
                      <mat-error>Maximum 100 Characters Allowed </mat-error>
                  </mat-form-field>
                  <div class="close-btn right-3" *ngIf="searchinput.value.search_field"
                      (click)="searchinput.patchValue({search_field :''});filterValidation(0)">
                  </div>
              </div>
              <div class="col-sm-2 col-xs-12 col-lg-2 col-md-2 mb-3">
                  <button class="blue_button float-end" style="margin-top: 3px !important;" mat-raised-button (click)="filterValidation(1)">Search</button>
              </div>

          </div>
      </form>
        <div class="checkBoxlign">
      <div class="table-responsive striped users_mod limit_height">
          <table class="col-12 multi_header_table  scrollling_table"
              (matSortChange)="sortData($event)" mat-table matSort [dataSource]="license_data">
              <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="bp_license_status_name" class="w120-container date-width">
                      Status
                  </th>
                  <td mat-cell *matCellDef="let element">{{element?.bp_license_status_name}}</td>
              </ng-container>

              <ng-container matColumnDef="Business Legal Name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="business_legal_name"> Business Legal Name
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element?.business_legal_name}}</td>
              </ng-container>

              <ng-container matColumnDef="License Type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="bp_license_type_name"> License Type
                </th>
                <td mat-cell *matCellDef="let element"> {{element?.bp_license_type_name}}</td>
            </ng-container>

            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef> Action</th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox (change)="onCheckboxChange(element, $event)"></mat-checkbox>
                <!-- <input type="checkbox" (change)="onCheckboxChange(element, $event)"> -->
                <!-- {{element?.bp_license_type_name}} -->
              </td>
          </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
      </div>
      <div class="col-12 text-center" *ngIf="license_data?.length == 0">
          <span class="NoDataFound">
              No Data Found
          </span>
      </div>
      <div class="col-12 bgWhite">
          <div class="row align-items-center ">
              <div class="col-12">
                  <mat-paginator *ngIf="license_data?.length != 0"
                      [pageSizeOptions]="page.pageSizeOptions" [length]="page.limit"
                      [pageSize]="page.pageSize" (page)="PageChange($event)" [pageIndex]="page.index"
                      showFirstLastButtons></mat-paginator>
              </div>
          </div>
      </div>
      <div class="col-sm-12 col-xs-12 col-lg-12 col-md-12 mt-4 mb-4">
        <button class="blue_button mb-4 float-end me-4" mat-raised-button (click)="submitSelectedRow()">Submit</button>
      </div>

  </div>
      </mat-card>
  </div>


    </div>
